import { HOME_TAB } from "../utilities/Constants";
import NavBar from "./NavBar";

const Header = () => {
    return (<>
        <NavBar activeItem={HOME_TAB} />
        <div className="mb-4"></div>
    </>
    )
}

export default Header;